



























import { Component, Vue, Prop } from "vue-property-decorator";
import StatBlock from "./StatBlock.vue";
import { ExtendedProjectModel } from "../models";
import dateflip from "shared/filters/dateflip";
import money from "shared/filters/money";

interface BlockData {
  label: string;
  value: string;
  tooltip: string;
  defaultValue?: string;
  titleFontSize?: string;
}

@Component({
  components: { StatBlock },
  filters: { dateflip, money },
})
export default class StatBlocks extends Vue {
  @Prop({ required: true, type: Object }) private value!: ExtendedProjectModel;

  get blockData(): BlockData[] {
    const t = (key: string): string =>
      this.$t("houseprojects.statsBlocks.management." + key).toString();
    return [
      {
        label: t("rentPrice.label"),
        value: this.$options.filters!.money(this.value.rent_price),
        tooltip: t("rentPrice.tooltip"),
      },
      {
        label: t("totalRent.label"),
        value: this.$options.filters!.money(this.value.total_rent),
        tooltip: t("totalRent.tooltip"),
      },
      {
        label: t("occupancyRate.label"),
        value: String(this.value.management_data!.occupancy_rate) + "%",
        tooltip: t("occupancyRate.tooltip"),
      },
      {
        label: t("lastBoilerMaintenanceDate.label"),
        value: this.$options.filters!.dateflip(
          this.value.heating.last_boiler_maintenance_date
        ),
        tooltip: t("lastBoilerMaintenanceDate.tooltip"),
        defaultValue: "Nooit",
        titleFontSize: "16px",
      },
    ];
  }
}
